/**
 * Values taken from the address bar (route params, query strings) that end
 * up inside a credentialed API path.
 *
 * react-router turns `%2F` inside a matched param back into `/`, and the URL
 * parser then collapses `..` segments. An unchecked value such as
 * `..%2F..%2Fsomething` in a dashboard link would therefore point a
 * cookie-authenticated request at a different API route.
 */

// Record identifiers in the API are short GUIDs in base64url
// ("WoV_kQNysESjACy9HJ8SDw"), so '_' and '-' are ordinary id characters;
// some older ids are plain GUIDs. The check allows the base64url alphabet,
// which never changes the path, and rules out '/', '.', '%' and the rest.
const SAFE_ID = /^[A-Za-z0-9_-]{1,64}$/;

export const isSafePathId = value => typeof value === 'string' && SAFE_ID.test(value);

// Route params that name a record (`:patientUuid`, `:accountUuid`, ...) are
// put straight into API paths by the pages. Checking them once, where every
// private route renders, covers every page and every future route.
const RECORD_ID_PARAM = /Uuid$/;

export const findUnsafeRouteId = (params = {}) =>
  Object.keys(params).find(
    name => RECORD_ID_PARAM.test(name) && params[name] !== undefined && !isSafePathId(params[name])
  );

// For values that are not plain ids (tokens): keep them inside one path
// segment, whatever characters they hold.
export const encodePathSegment = value => encodeURIComponent(String(value));
